// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"98":"hire-me","259":"workspace","443":"about","903":"not-found-page"}[chunkId] + "." + {"98":"69303d64","259":"6c7acfb4","443":"30af607c","903":"611d4e70"}[chunkId] + ".js";
};